export default __webpack_public_path__ + "static/mob-img01-2ade20a08dde810decfb0cf2c7008f1a.png";